import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';

const httpLink = new HttpLink({
  uri: process.env.REACT_APP_BASE_URL + "/graphql/default",
  // headers: {
  // authorization: localStorage.getItem('token') || '',
  // 'client-name': 'Space Explorer [web]',
  // 'client-version': '1.0.0',
  // }
});

export const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
});

// const httpLink = new HttpLink({ uri: '/graphql' });
//
// const logoutLink = onError(({ networkError }) => {
//   if (networkError.statusCode === 401) logout();
// })
//
// const client = new ApolloClient({
//   cache: new InMemoryCache(),
//   link: logoutLink.concat(httpLink),
// });
